// Exists so these can be imported from both client and server component
const navElementClasses = `cursor-pointer whitespace-nowrap rounded-full px-4 py-1 text-sm text-gray-900 outline-none
transition-colors data-[focused]:bg-gray-200 data-[pressed]:bg-gray-200 hover:bg-gray-200 group-hover:bg-gray-200`;

/**
 * the wrapper element for a nav element determines the minimum amount of space the
 *item requires.  slightly off centre because the nav items give the illusion of
 * being off centre relative to the logo otherwise.
 **/
const navElementWrapperClasses = "pb-[0.9rem] pt-[1.1rem]";

const navDropdownClasses =
	"flex flex-col gap-2.5 rounded-b bg-white p-4 pb-8 outline-none min-w-80 text-sm";

const navDropdownElementClasses =
	"group block px-4 py-2 text-sm focus-visible:outline-0 focus-visible:ring-0";

export {
	navElementClasses,
	navElementWrapperClasses,
	navDropdownClasses,
	navDropdownElementClasses,
};
